export const pushDataLayerEvent = (
  event,
  eventCategory,
  eventAction,
  eventLabel
) => {
  const isProdOrStaging = ['production', 'staging', 'strabag'].includes(
    import.meta.env.VITE_TARGET_ENV
  )

  if (!isProdOrStaging) return null

  try {
    window.dataLayer.push({
      event,
      eventCategory,
      eventAction,
      eventLabel
    })
  } catch (err) {
    console.error(err)
  }
}
